import { useSearchParams, useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { localDateFromString, localDateToString, getStartOfWeek, getEndOfWeek } from '@/utils/datetime';
import { AddToShoppingListModal } from '@/features/shopping-list/components/AddToShoppingListModal';
import { useGetFromMealPlanQuery } from '@/features/shopping-list/api';
import { dateRangeToPrettyString } from '@/utils/datetime';
import { useGetHouseholdQuery } from '@/features/households/api';

export function AddToShoppingListPage() {
  const [searchParams] = useSearchParams();
  const { householdId } = useParams();
  const { data: householdData } = useGetHouseholdQuery({ householdId });
  const weekStartDay = householdData?.data?.week_start_day ?? 1;

  const dateParam = searchParams.get('date');
 
  const fromDate = useMemo(() => {
    const date = dateParam ? localDateFromString(dateParam) : new Date();
    return getStartOfWeek(date, weekStartDay);
  }, [dateParam, weekStartDay]);
  const toDate = useMemo(() => getEndOfWeek(fromDate), [fromDate]);
  
  const apiResult = useGetFromMealPlanQuery({ householdId, fromDate: localDateToString(fromDate), toDate: localDateToString(toDate) });  
  
  return (    
    <AddToShoppingListModal      
      verb="Create"
      source={`meal plan (${dateRangeToPrettyString(fromDate, toDate)})`}
      {...apiResult}
    />
  );
}